import { Modal } from 'react-bootstrap'
import AdministratorMarginDetailsReport from './AdministratorMarginDetailsReport'

export default function AdministratorMarginDetailsModal({ modalData, setModalData }){
    return (
        <Modal show={modalData.open} onHide={() => setModalData({...modalData, open:false})} size="xl" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>Administrator Margin Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <AdministratorMarginDetailsReport
                    id={modalData.marginId}
                    year={modalData.year}
                    quarter={modalData.quarter}
                    propMode={modalData.mode}
               />
            </Modal.Body>
        </Modal>
    )
}